export function stripMetaProperties<T>(data: T): T {
  const newItem = { ...data };
  delete newItem['id'];

  return newItem;
}
